import MAConceptWebsite from './components/MAConceptWebsite';
import { LanguageProvider } from './context';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <MAConceptWebsite />
      </div>
    </LanguageProvider>
  );
}

export default App;
